import React from 'react';
import { IProps } from './type';

const ArrowUpwardIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      className={cName}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox={viewBox ? viewBox : '0 0 24 24'}
      fill={fillColor ? fillColor : 'none'}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 6L12.3536 5.64645L12 5.29289L11.6464 5.64645L12 6ZM11.5 18C11.5 18.2761 11.7239 18.5 12 18.5C12.2761 18.5 12.5 18.2761 12.5 18L11.5 18ZM16.3536 9.64645L12.3536 5.64645L11.6464 6.35355L15.6464 10.3536L16.3536 9.64645ZM11.6464 5.64645L7.64645 9.64645L8.35355 10.3536L12.3536 6.35355L11.6464 5.64645ZM11.5 6L11.5 18L12.5 18L12.5 6L11.5 6Z"
        fill={fillColor ? fillColor : "#212121"} />
    </svg>
  )
};

export default ArrowUpwardIcon;
